import tw from "twin.macro"
import Icon from "../../atoms/Icon"
import { detectMobileView } from "../../../helpers"
import { PartArticlesFilterProps } from "./CarCareSubNav.d"
import { useContext, useEffect, useState } from "react"
import { LanguageContext } from "../../../contexts/Language"

const PartArticlesFilter = ({
  parts,
  selectedParts,
  showPartsFilter,
  setShowPartsFilter,
  handleSelectChange,
}: PartArticlesFilterProps) => {
  const { _ } = useContext(LanguageContext)
  const [isMobile, setIsMobile] = useState<boolean>()
  useEffect(() => {
    setIsMobile(detectMobileView())
  }, [])

  return (
    <div
      css={[
        tw`w-full mx-auto flex flex-col justify-center text-center mt-10 gap-10 text-lg lg:(mt-20)`,
      ]}
    >
      {isMobile ? (
        <div>
          <button
            css={[
              tw`bg-black rounded-md py-2 px-4 mx-auto text-white text-xs font-semibold flex items-center gap-5`,
            ]}
            onClick={() => setShowPartsFilter(!showPartsFilter)}
          >
            <Icon.Filter css={[tw`h-5`]} color="white" />
            {_("Filter Parts Articles")}
            <Icon.Chevron
              color="white"
              direction="down"
              css={[
                tw`h-3 transition-all duration-300 mt-0.5 ml-1`,
                showPartsFilter && tw`transform -rotate-180`,
              ]}
            />
          </button>
        </div>
      ) : (
        <div>{_("Filter Parts Articles")}</div>
      )}
      <ul
        css={[
          tw`flex flex-wrap justify-center gap-5`,
          isMobile && tw`flex-col gap-5`,
        ]}
      >
        {showPartsFilter &&
          parts?.map((part, index) => {
            const HeadingIcon =
              part.icon && Icon[part.icon as keyof typeof Icon]
            const isActive = selectedParts.includes(part.name)
            return (
              <li key={part._id} css={[isMobile && tw`flex justify-center`]}>
                <button
                  css={[
                    isActive
                      ? tw`bg-black text-white  hover:(bg-gray-800)`
                      : tw`bg-wildSand py-2 px-5 rounded-full flex items-center gap-2 hover:(bg-[#ecebeb])`,
                    tw`py-2 px-5 rounded-full flex flex-nowrap items-center gap-2`,
                  ]}
                  onClick={() => handleSelectChange(part.name)}
                  analytics-id={`parts filter:articles:${index + 1}`}
                >
                  {isActive && <Icon.X css={[tw`h-3 fill-current`]} />}
                  {HeadingIcon && (
                    <HeadingIcon
                      css={[tw`h-4`]}
                      color={isActive ? "white" : "black"}
                    />
                  )}
                  {part.name}
                </button>
              </li>
            )
          })}
      </ul>
    </div>
  )
}

export default PartArticlesFilter
